=
<template>
  <q-table
    flat
    ref="tableRef"
    :rows="rows"
    :columns="columns"
    row-key="id"
    :loading="loading"
    v-model:pagination="pagination"
    @request="onRequest"
    binary-state-sort
    class="external-dns-table"
    :rows-per-page-options="rowsPerPageOptions"
  >
    <template v-slot:no-data>
      <div class="flex full-width column items-center q-py-lg">
        <q-icon name="mdi-cloud-search" class="q-mb-sm" size="40px" color="primary"></q-icon>
        <span class="block" style="font-size: 14px">No items were found.</span>
      </div>
    </template>
    <template v-slot:body-cell-orderable="props">
      <q-td :props="props">
        <q-icon
          :name="props.row.orderable ? 'check' : 'remove'"
          :color="props.row.orderable ? 'positive' : 'negative'"
        ></q-icon>
      </q-td>
    </template>
    <template v-slot:body-cell-is_catalog_part="props">
      <q-td :props="props">
        <q-icon
          :name="props.row.is_catalog_part ? 'check' : 'remove'"
          :color="props.row.is_catalog_part ? 'positive' : 'negative'"
        ></q-icon>
      </q-td>
    </template>
    <template v-slot:body-cell-actions="props">
      <q-td :props="props">
        <q-btn
          flat
          round
          size="12px"
          icon="sym_r_edit"
          style="width: 30px; height: 40px"
          class="btn--no-hover"
          @click="$emit('editService', props.row)"
        >
          <q-tooltip>Edit</q-tooltip>
        </q-btn>
      </q-td>
    </template>
  </q-table>
</template>

<script>
import dayjs from 'dayjs';
import { getInfraServices } from '../api/api';

export default {
  name: 'InfraServicesTable',
  props: {
    filters: {
      type: Object,
      default: () => ({}),
    },
    rowsPerPageOptions: {
      type: Array,
      default: () => [20, 50, 100],
    },
  },
  emits: ['editService'],
  data() {
    return {
      rows: [],
      loading: false,
      pagination: {
        sortBy: 'updatedAt',
        descending: true,
        page: 1,
        rowsPerPage: 20,
        rowsNumber: 0,
      },
      columns: [
        {
          name: 'apmid',
          label: 'APMID',
          field: 'apmid',
          align: 'left',
          sortable: true,
        },
        {
          name: 'display_name',
          label: 'Display Name',
          field: 'display_name',
          align: 'left',
        },
        {
          name: 'kind',
          label: 'Kind',
          field: 'kind',
          align: 'left',
        },
        {
          name: 'orderable',
          label: 'Orderable',
          field: 'orderable',
          align: 'left',
        },
        {
          name: 'is_catalog_part',
          label: 'Is Catalog Part',
          field: 'is_catalog_part',
          align: 'left',
        },
        {
          name: 'createdAt',
          label: 'Created At',
          field: 'createdAt',
          align: 'left',
          format: (val) => dayjs(val).format('DD.MM.YYYY HH:mm'),
          sortable: true,
        },
        {
          name: 'updatedAt',
          label: 'Updated At',
          field: 'updatedAt',
          align: 'left',
          format: (val) => dayjs(val).format('DD.MM.YYYY HH:mm'),
          sortable: true,
        },
        {
          name: 'actions',
          label: '',
          field: 'actions',
          align: 'right',
          sortable: false,
        },
      ],
    };
  },
  methods: {
    async onRequest(props) {
      const { page, rowsPerPage, sortBy, descending } = props.pagination;

      this.loading = true;

      try {
        this.relatedWorkflowStatuses = [];
        const skip = page === 1 ? 0 : (page - 1) * rowsPerPage;
        const { count, data } = await getInfraServices(
          rowsPerPage,
          skip,
          sortBy,
          descending,
          this.filters.displayName,
          this.filters.apmId,
          this.filters.orderable,
          this.filters.isCatalogPart,
          this.filters.parentOnly,
          this.filters.deleted,
          this.filters.kind,
        );
        this.rows = data;
        this.pagination = { ...props.pagination, rowsNumber: count };
        this.$router.replace({ query: this.buildQueryFromFilters() });
      } catch (error) {
        this.$notify('negative', 'Error', error.message);
        this.rows = [];
      } finally {
        this.loading = false;
      }
    },
    buildQueryFromFilters() {
      const query = {};
      for (const key in this.filters) {
        if (this.filters[key] !== undefined && this.filters[key] !== null && this.filters[key] !== '') {
          query[key] = String(this.filters[key]);
        }
      }
      if (this.pagination.sortBy) {
        query.sortBy = this.pagination.sortBy;
        query.descending = String(this.pagination.descending);
      }
      query.page = String(this.pagination.page);
      query.rowsPerPage = String(this.pagination.rowsPerPage);
      return query;
    },
    reload() {
      this.onRequest({ pagination: this.pagination });
    },
  },
  mounted() {
    const query = this.$route.query;
    if (query.sortBy) this.pagination.sortBy = query.sortBy;
    if (query.descending) this.pagination.descending = query.descending === 'true';
    if (query.page) this.pagination.page = Number(query.page);
    if (query.rowsPerPage) this.pagination.rowsPerPage = Number(query.rowsPerPage);
  },
};
</script>

<style lang="scss" scoped>
.long-desc {
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
}

.sticky-header-table {
  max-height: 100%;

  :deep(thead tr th) {
    position: sticky;
    z-index: 1;
    background: white;
  }

  :deep(thead tr:first-child th) {
    top: 0;
  }
}
</style>
